var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11 5.218a1.652 1.652 0 00-1.838 1.08.826.826 0 01-1.558-.549 3.304 3.304 0 016.421 1.101c0 1.265-.938 2.1-1.607 2.546a6.649 6.649 0 01-1.393.7l-.028.01-.01.004h-.003l-.001.001-.262-.783.261.784a.826.826 0 01-.523-1.568h-.001l.014-.004a4.83 4.83 0 00.3-.122c.204-.09.47-.224.73-.397.57-.38.87-.784.87-1.171v-.002a1.652 1.652 0 00-1.372-1.63zm-1.04 7.414c0-.456.37-.826.827-.826h.008a.826.826 0 010 1.652h-.008a.826.826 0 01-.826-.826z",
    fill: "#fff"
  })));
}

export default SvgQuestionCircle;